import React from "react";
import ReactModal from "react-modal";
import { FormProvider } from "react-hook-form";
import { Input, Draggable } from "@components";
import { useMemberInfoLogic } from "@hooks";

function MemberInfoModal({
  isOpen,
  onClose,
}) {
  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  const {
    handleSubmit,
    onSubmit,
    onError,
    ...methods
  } = useMemberInfoLogic({ isOpen, onClose });

  const { errors } = methods.formState;


  const containerStyle = {
    maxWidth: "1050px",
    minWidth: "1050px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="modal-overlay"
        className="modal-wrap"
      >
        <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="modal-container" style={containerStyle}>
              <div className="modal-header" style={{ cursor: "move" }}>
                <h5>
                  회원 정보
                </h5>
                <button type="button" className="modal-btn-close" onClick={onClose}>
                  <span className="modal-btn-span">X</span>
                </button>
              </div>
              <div className="modal-content">
                  <table className="table-write" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th>아이디</th>
                        <td>
                          <Input
                            name="id"
                            disabled
                            style={{ width: "100%" }}
                          />
                        </td>
                        <th>비밀번호</th>
                        <td>
                          <Input
                            name="password"
                            type="password"
                            placeholder="변경 시 입력 (빈 칸이면 유지)"
                            style={{ width: "100%" }}
                          />
                          {errors.password && (
                            <p style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                              {errors.password.message}
                            </p>
                          )}
                        </td>
                      </tr>
                      <tr>
                      <th>이름</th>
                        <td>
                          <Input
                            name="name"
                            maxLength="10"
                            style={{ width: "100%" }}
                          />
                          {errors.name && (
                            <p style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                              {errors.name.message}
                            </p>
                          )}
                        </td>
                        <th>전화번호</th>
                        <td>
                          <Input
                            name="phoneNo"
                            maxLength="11"
                            placeholder="- 없이 숫자만 입력해 주세요."
                            style={{ width: "100%" }}
                          />
                          <p style={{ fontSize: '11px', color: '#888', margin: '3px 0 0' }}>- 없이 숫자만 입력하세요.</p>
                        </td>
                      </tr>
                      <tr>
                      <th>이메일</th>
                        <td colSpan={3}>
                          <Input
                            name="email"
                            maxLength="100"
                            style={{ width: "100%" }}
                          />
                          {errors.email && (
                            <p style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                              {errors.email.message}
                            </p>
                          )}
                        </td>

                      </tr>


                    </tbody>
                  </table>
              </div>
              <div className="modal-btn-wrap btn-right-box">
                <ul>
                  <li><button type="button" className="btn-cancel" onClick={onClose}>취소</button></li>
                  <li><button type="submit" className="btn-save" >저장</button></li>
                </ul>
              </div>
            </div>
            </form>
        </FormProvider>
      </ReactModal>
    </>
  );
}

export { MemberInfoModal };
